/**
 * 自定义指令统一注册
 */
import placeholder from './placeholder'

const directives = {
  // 开发环境占位图指令
  'dev-placeholder': placeholder
}

/**
 * 批量注册自定义指令
 * @param {Vue} Vue - Vue 实例
 */
export default {
  install(Vue) {
    Object.keys(directives).forEach(key => {
      Vue.directive(key, directives[key])
    })
  }
}
